import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { useHistory } from '@treams/treams-routes';
import { Modal, Popover } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import ChevronRightSmallIcon from 'packages/kakapo-ui-kit/assets/icons/ChevronRightSmallIcon';

import Color from '../common/Color';

import CycleMomentSelector, { MomentTitle } from './CycleMomentSelector';
import Paragraph from '../common/Paragraph';

const Line = styled(Box)`
	height: 1px;
	background: ${(props) => props.theme.colors.lightBlue};
`;

export const Card = styled(Box)`
	border-radius: 4px;
	border: 1px solid ${(props) => props.theme.colors.lightBlue};
	cursor: pointer;

	svg {
		display: block;
	}

	&:hover {
		background: ${(props) => props.theme.colors.whiteBlue};

		&:active {
			background: ${(props) => props.theme.colors.lightBlueLight};
		}
	}
`;

export default function CycleMomentSelectorModal(props: {
	type: graphql.MomentType;
	regularURL: string;
	momentURL: (moment: graphql.MomentInstance) => string;
	returnURL: string;
}) {
	const { t } = useTranslation();
	const history = useHistory();

	return (
		<Popover visible center>
			<Modal>
				<Modal.Header title={t(`cycle.momentSelector.${props.type.toLowerCase()}.title`)} />
				<Modal.Contents>
					<Box>
						<Paragraph color="slateBlue">
							{t(`cycle.momentSelector.${props.type.toLowerCase()}.description`)}
						</Paragraph>
						<CycleMomentSelector
							type={props.type}
							onSelect={(moment, automatic) => {
								const url = moment ? props.momentURL(moment) : props.regularURL;
								if (automatic) {
									history.replace(url);
								} else {
									history.push(url);
								}
							}}
						/>
					</Box>
					<Flex alignItems="center" my={4}>
						<Line flexGrow={1} flexShrink={1} />
						<Box px={2}>
							<Color color="slateBlue">{t('cycle.momentsSelector.or')}</Color>
						</Box>
						<Line flexGrow={1} flexShrink={1} />
					</Flex>
					<Box>
						<Paragraph color="slateBlue">
							{t('cycle.momentSelector.alternative.description')}
						</Paragraph>
						<Card p={3} mt={2} onClick={() => history.push(props.regularURL)}>
							<Flex alignItems="center">
								<Box flexGrow={1} flexShrink={1}>
									<MomentTitle>
										{t(`cycle.momentSelector.${props.type.toLowerCase()}.action`)}
									</MomentTitle>
								</Box>

								<Flex alignItems="center" flexGrow={0} flexShrink={0}>
									<Box flexGrow={0} flexShrink={0} mr={1}>
										<Color color="primary">{t('cycle.momentsSelector.select')}</Color>
									</Box>
									<ChevronRightSmallIcon color="primary" />
								</Flex>
							</Flex>
						</Card>
					</Box>
				</Modal.Contents>
				<Modal.FormFooter onCancel={() => history.push(props.returnURL)} disabled />
			</Modal>
		</Popover>
	);
}
